export default "__VITE_ASSET__942e6f3f__"